module.exports = {
	"ha": "bc",
	"id": 5.3,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2018 Q3–2020 Q2",
		"lastYear": "2020",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Age Category, Year Ending 2020 Q2 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -130,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 70.53045186640472,
						"dataLabels": {
							"enabled": true,
							"format": "359",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 60.90373280943025,
						"dataLabels": {
							"enabled": true,
							"format": "310",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 56.188605108055015,
						"dataLabels": {
							"enabled": true,
							"format": "286",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 48.33005893909627,
						"dataLabels": {
							"enabled": true,
							"format": "246",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 31.630648330058943,
						"dataLabels": {
							"enabled": true,
							"format": "161",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 94.84777517564403,
						"dataLabels": {
							"enabled": true,
							"format": "1215",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80.09367681498829,
						"dataLabels": {
							"enabled": true,
							"format": "1026",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 75.17564402810304,
						"dataLabels": {
							"enabled": true,
							"format": "963",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 67.05698672911787,
						"dataLabels": {
							"enabled": true,
							"format": "859",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 49.57064793130367,
						"dataLabels": {
							"enabled": true,
							"format": "635",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 94.79905437352247,
						"dataLabels": {
							"enabled": true,
							"format": "2005",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 78.62884160756501,
						"dataLabels": {
							"enabled": true,
							"format": "1663",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 72.57683215130024,
						"dataLabels": {
							"enabled": true,
							"format": "1535",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 65.34278959810875,
						"dataLabels": {
							"enabled": true,
							"format": "1382",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 45.579196217494086,
						"dataLabels": {
							"enabled": true,
							"format": "964",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 95.17409896151496,
						"dataLabels": {
							"enabled": true,
							"format": "6232",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 77.94746487477092,
						"dataLabels": {
							"enabled": true,
							"format": "5104",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 72.93830177153329,
						"dataLabels": {
							"enabled": true,
							"format": "4776",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 69.39523518631643,
						"dataLabels": {
							"enabled": true,
							"format": "4544",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 52.840562003665234,
						"dataLabels": {
							"enabled": true,
							"format": "3460",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -29.469548133595282,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.649025069637888,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.741935483870965,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.98601398601399,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -34.552845528455286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -5.152224824355967,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -15.555555555555555,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.140350877192979,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.799584631360338,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -26.07683352735739,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -5.200945626477537,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -17.057356608478802,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.696933253156946,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.967426710097715,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -30.246020260492045,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -4.8259010384850365,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -18.10012836970475,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.426332288401248,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.8576214405360085,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -23.8556338028169,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=509"
			},
			{
				"x": 9,
				"text": "30–39<br>n=1281"
			},
			{
				"x": 15,
				"text": "40–49<br>n=2115"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=6548"
			}
		],
		"dataTable": {
			"< 30": [
				509,
				359,
				310,
				286,
				246,
				161
			],
			"30–39": [
				1281,
				1215,
				1026,
				963,
				859,
				635
			],
			"40–49": [
				2115,
				2005,
				1663,
				1535,
				1382,
				964
			],
			"≥ 50": [
				6548,
				6232,
				5104,
				4776,
				4544,
				3460
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_3.json
// module id = 168
// module chunks = 0